import qs from 'qs';

/**
 * V3: Helper to generate url for recommendation request
 * @param {string} slotId mandatory identifier of slot
 * @param {number} pageSize mandatory, limit items fetched
 * @param {Int32Array} seedItemIds optional item list that will act as seed for recommendation
 */
const recommendationsV3RequestBuilder = (
    slotId,
    pageSize,
    seedItemIds = []
) => {
    const endpoint = '/ma/recommendations-v3';

    return (pageIndex = 0) => {
        let queryParameters = {
            slotId,
            pageSize,
            pageIndex
        };

        if (!!seedItemIds && seedItemIds.length > 0) {
            queryParameters.seedItemIds = seedItemIds;
        }

        return `${endpoint}?${qs.stringify(queryParameters)}`;
    };
};

export { recommendationsV3RequestBuilder };



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/recommendations/recommendation-request.js